import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./CourseTeachers.module.scss";
import {CourseTeacher, ICourseTeacherProps} from "./courseTeacher/CourseTeacher";
import {isUndefined} from "../../../util/is-type";

export interface ICourseTeachersProps {
  teachers?: ICourseTeacherProps[];
}

export const CourseTeachers: VoidFunctionComponent<ICourseTeachersProps> = ({teachers}) => {
  if (isUndefined(teachers)){
    return null;
  }
  return (
    <div className={s.courseTeachers}>
      <h3>Teacher{teachers.length > 1 ? 's' : ''}</h3>
      <ul className={s.teacherList}>
        {teachers.map(({teacherName, teacherImgUrl}, teacherIndex) => {
          return (
            <CourseTeacher
              key={`teacher-${teacherIndex}-${teacherName}`}
              teacherImgUrl={teacherImgUrl}
              teacherName={teacherName}
            />
          );
        })}
      </ul>
    </div>
  );
}

